<template>
  <!-- lista "kategorija + naslov" na pocetnoj (Recepti, Kako pomaze): naslov i "Pogledaj sve" vode na routeTo -->
  <RecipesBlock
    :items="items"
    :title="title"
    :title-to="{ name: routeTo, params: { page: 1 } }"
    :item-route="routeToTitle"
    layout="feed"
    show-all
  />
</template>

<script setup>
import RecipesBlock from '~/components/widgets/Recipe/RecipesBlock.vue'

defineProps({
  items: { type: Array, default: () => [] },
  title: { type: String, default: '' },
  // ruta liste (npr. 'recepti-page', 'kako-pomaze-kategorije-page')
  routeTo: { type: String, default: 'recepti-page' },
  // ruta pojedinacnog teksta (npr. 'recept-category-title-id', 'kako-pomaze-category-title-id')
  routeToTitle: { type: String, default: 'recept-category-title-id' },
})
</script>
